import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Music2 } from "lucide-react";

export default function SiteFooter({ settings, footer }) {
  const columns = footer?.columns || [];
  const socials = settings?.socials || {};
  const socialItems = [
    { key: "instagram", Icon: Instagram },
    { key: "facebook", Icon: Facebook },
    { key: "linkedin", Icon: Linkedin },
    { key: "tiktok", Icon: Music2 },
  ].filter((s) => socials[s.key]);

  return (
    <footer data-testid="site-footer" className="bg-[#2C3531] text-[#FDFBF7] mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <p className="font-display text-3xl font-semibold mb-4">{settings?.site_name || "Grow Your Bookings"}</p>
            <p className="text-sm text-[#FDFBF7]/70 leading-relaxed max-w-xs">{footer?.tagline}</p>
            {settings?.contact_email && (
              <a href={`mailto:${settings.contact_email}`} className="inline-block mt-5 text-sm text-[#9A8C73] hover:text-[#FDFBF7] transition-colors">{settings.contact_email}</a>
            )}
            {socialItems.length > 0 && (
              <div className="flex gap-3 mt-6">
                {socialItems.map(({ key, Icon }) => (
                  <a key={key} href={socials[key]} target="_blank" rel="noreferrer" data-testid={`social-${key}`}
                    className="w-9 h-9 rounded-full border border-[#FDFBF7]/20 flex items-center justify-center hover:bg-[#FDFBF7]/10 transition-colors">
                    <Icon className="w-4 h-4" strokeWidth={1.75} />
                  </a>
                ))}
              </div>
            )}
          </div>
          {columns.map((col, i) => (
            <div key={i}>
              <p className="uppercase tracking-[0.2em] text-xs font-bold text-[#9A8C73] mb-5">{col.title}</p>
              <ul className="space-y-3">
                {(col.links || []).map((l, j) => (
                  <li key={j}>
                    <Link to={l.href} className="text-sm text-[#FDFBF7]/75 hover:text-[#FDFBF7] transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-[#FDFBF7]/15 text-xs text-[#FDFBF7]/50">
          {footer?.legal || "\u00a9 2026 Grow Your Bookings."}
        </div>
      </div>
    </footer>
  );
}
